import React from "react"
import { useTranslation } from 'react-i18next'

import { formatMoney } from 'helpers/helpers'

// Статусы точек в фильтре списка — те же id и подписи, что в мультиселекте «Статус»
export const POS_STATUSES = [
	{ 'id': 1, 'name': "Активный" },
	{ 'id': -1, 'name': "Отключен" },
	{ 'id': -3, 'name': "Удален" },
]

// Ключ счётчика в ответе (data.status) и цвет плашки для каждого статуса
const TOGGLES = [
	{ id: 1, countKey: 'total_active', label: 'active', className: 'bg-primary' },
	{ id: -1, countKey: 'total_not_active', label: 'disconnected', className: 'bg-secondary' },
	{ id: -3, countKey: 'total_deleted', label: 'deleted', className: 'bg-danger' },
]

/**
 * Плашки со счётчиками статусов — они же быстрый фильтр: клик включает статус
 * в мультиселект фильтра, повторный клик убирает. Выключенная плашка бледная.
 * Счётчики приходят без учёта фильтра, поэтому выключение цифру не обнуляет.
 */
export function togglePosStatus(statusIds, id) {
	const current = statusIds || []
	if (current.some(item => item.id === id)) {
		return current.filter(item => item.id !== id)
	}
	// Порядок как в справочнике, чтобы чипы в селекте не прыгали
	const next = [...current, POS_STATUSES.find(item => item.id === id)]
	return POS_STATUSES.filter(status => next.some(item => item.id === status.id))
}

/**
 * Плашка «Кредит» — точки с действующим доверительным платежом, т.е. кредит взят
 * и ещё не оплачен (оплата отзывает его). Это не статус, а отдельный флаг фильтра
 * credit_only: складывается со статусами. В подсказке — их общий долг.
 */
function PosStatusToggles({ counts, statusIds, onToggle, creditOn, onCreditToggle }) {
	const { t } = useTranslation()

	return (
		<div className="d-flex gap-2">
			{TOGGLES.map(toggle => {
				const isOn = (statusIds || []).some(item => item.id === toggle.id)

				return (
					<div className="vertical-center" key={toggle.id}>
						<span role="button"
							className={`${toggle.className} bg-border text-white user-select-none`}
							style={{ cursor: 'pointer', opacity: isOn ? 1 : 0.4 }}
							title={isOn ? 'Убрать из фильтра' : 'Добавить в фильтр'}
							onClick={() => onToggle(toggle.id)}>
							<span>{t(toggle.label)}: {counts?.[toggle.countKey]}</span>
						</span>
					</div>
				)
			})}
			{onCreditToggle &&
				<div className="vertical-center">
					<span role="button"
						className="bg-warning bg-border text-dark user-select-none"
						style={{ cursor: 'pointer', opacity: creditOn ? 1 : 0.4 }}
						title={`Кредит взят и ещё не оплачен. Долг: ${formatMoney(counts?.total_credit_debt)}`}
						onClick={onCreditToggle}>
						<span>{t('credit')}: {counts?.total_credit}</span>
					</span>
				</div>
			}
		</div>
	)
}

export default PosStatusToggles
